exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".active[data-v-fb856a1e]{font-weight:700}.active[data-v-fb856a1e]:before{content:\"\";position:absolute;width:100%;height:3px;background-color:var(--portalPrimaryTextColor);bottom:-7px}.sub-nav-item[data-v-fb856a1e]:hover{color:var(--portalPrimaryColor)}", ""]);

// exports
